import React, { useState } from 'react';
import { Sparkle, Check, Cube, PencilSimple, ArrowRight } from '@phosphor-icons/react';
import { Button } from '../ui/Button';
import { updateProperty, type SavedProperty } from '../../lib/utils';
interface SuccessScreenProps {
  tenantName: string;
  property: SavedProperty | null;
  matchType: 'new' | 'name' | 'signature' | null;
  onClose: () => void;
  onViewProperty?: (id: string) => void;
}
export function SuccessScreen({
  tenantName,
  property,
  matchType,
  onClose,
  onViewProperty
}: SuccessScreenProps) {
  const [savedProperty, setSavedProperty] = useState<SavedProperty | null>(property);
  const [overridden, setOverridden] = useState(false);
  const [isRenaming, setIsRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState(property?.name || '');
  const handleConfirmRename = () => {
    if (!savedProperty) return;
    const trimmed = renameValue.trim();
    if (!trimmed || trimmed === savedProperty.name) {
      setIsRenaming(false);
      return;
    }
    const updated = updateProperty(savedProperty.id, {
      name: trimmed
    });
    if (updated) setSavedProperty(updated);
    setIsRenaming(false);
  };
  return <div className="py-8 flex flex-col items-center max-w-md mx-auto" data-id="element-2759">
      <Sparkle size={64} weight="fill" className="text-lime-1 mb-4" data-id="element-2760" />
      <h3 className="text-xl font-semibold text-light-1 mb-2 text-center" data-id="element-2761">
        Ofertă trimisă!
      </h3>
      <p className="text-light-2 mb-6 text-center" data-id="element-2762">
        {tenantName} a fost notificat/ă. Vei primi un răspuns în curând pe
        email.
      </p>

      {savedProperty && (matchType === 'new' || overridden) && <div className="w-full mb-6 rounded-xl bg-lime-5 border border-lime-4 p-4 sm:p-5" data-id="element-2763">
          <div className="flex items-start gap-3" data-id="element-2764">
            <div className="shrink-0 w-9 h-9 rounded-lg bg-lime-1/20 border border-lime-4 inline-flex items-center justify-center mt-0.5" data-id="element-2765">
              <Check size={18} weight="bold" className="text-lime-1" data-id="element-2766" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-2767">
              <p className="text-xs font-medium text-lime-1 uppercase tracking-wider mb-1" data-id="element-2768">
                Salvat ca proprietate nouă
              </p>
              {isRenaming ? <div className="flex items-center gap-2 mt-1" data-id="element-2769">
                  <input type="text" value={renameValue} onChange={e => setRenameValue(e.target.value)} autoFocus onKeyDown={e => {
              if (e.key === 'Enter') handleConfirmRename();
              if (e.key === 'Escape') {
                setRenameValue(savedProperty.name);
                setIsRenaming(false);
              }
            }} className="flex-1 h-9 px-3 rounded-md bg-dark-2 border border-dark-4 text-sm text-light-1 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2770" />
                  <button type="button" onClick={handleConfirmRename} className="inline-flex items-center h-9 px-3 rounded-md bg-lime-1 hover:bg-lime-2 text-dark-1 text-xs font-semibold transition-colors cursor-pointer" data-id="element-2771">
                    OK
                  </button>
                </div> : <p className="text-base font-semibold text-light-1 truncate" data-id="element-2772">
                  «{savedProperty.name}»
                </p>}
              {!isRenaming && <div className="mt-3 flex items-center gap-4 flex-wrap" data-id="element-2773">
                  <button type="button" onClick={() => {
              setRenameValue(savedProperty.name);
              setIsRenaming(true);
            }} className="inline-flex items-center gap-1.5 text-xs font-medium text-light-2 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2774">
                    <PencilSimple size={14} data-id="element-2775" />
                    Redenumește
                  </button>
                  {onViewProperty && <button type="button" onClick={() => onViewProperty(savedProperty.id)} className="inline-flex items-center gap-1.5 text-xs font-semibold text-lime-1 hover:text-lime-2 transition-colors cursor-pointer" data-id="element-2776">
                      Vezi proprietatea
                      <ArrowRight size={14} weight="bold" data-id="element-2777" />
                    </button>}
                </div>}
            </div>
          </div>
        </div>}

      {savedProperty && matchType && matchType !== 'new' && !overridden && <div className="w-full mb-6 rounded-xl bg-dark-3 border border-dark-4 p-4 sm:p-5" data-id="element-2778">
          <div className="flex items-start gap-3 mb-3" data-id="element-2779">
            <div className="shrink-0 w-9 h-9 rounded-lg bg-dark-2 border border-dark-4 inline-flex items-center justify-center mt-0.5" data-id="element-2780">
              <Cube size={18} className="text-light-2" data-id="element-2781" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-2782">
              <p className="text-xs font-medium text-light-3 uppercase tracking-wider mb-1" data-id="element-2783">
                {matchType === 'name' ? 'Pare să fie o proprietate pe care o ai deja' : 'Aceleași facilități ca o proprietate salvată'}
              </p>
              <p className="text-base font-semibold text-light-1 truncate" data-id="element-2784">
                «{savedProperty.name}»
              </p>
              <p className="text-xs text-light-3 mt-1 leading-relaxed" data-id="element-2785">
                Oferta a fost atașată acestei proprietăți.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-wrap" data-id="element-2786">
            <button type="button" onClick={() => setOverridden(true)} className="inline-flex items-center text-xs font-medium text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2787">
              Salvează ca proprietate nouă
            </button>
            {onViewProperty && <button type="button" onClick={() => onViewProperty(savedProperty.id)} className="ml-auto inline-flex items-center gap-1.5 text-xs font-semibold text-lime-1 hover:text-lime-2 transition-colors cursor-pointer" data-id="element-2788">
                Vezi proprietatea
                <ArrowRight size={14} weight="bold" data-id="element-2789" />
              </button>}
          </div>
        </div>}

      <Button onClick={onClose} className="bg-dark-3 hover:bg-dark-4 text-light-1 font-medium h-11 px-8 border border-dark-4" data-id="element-2790">
        Închide
      </Button>
    </div>;
}